import React from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentUser } from 'selectors/users';

import AvatarBase from 'components/avatar-base';

const CurrentUser = ({ user, onClick }) => {
    return (
        <div className="current-user prevent-open" onClick={onClick}>
            <AvatarBase image={user.avatar} color={user.color} secondaryColor={user.secondary_color} text={user.initials} size="small" />
        </div>
    )
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();

    return ({ users }, ownProps) => ({
        user: getCurrentUser(users)
    });
}

export default connect(makeMapStateToProps)(CurrentUser);
